import React from 'react'
import get from 'lodash/get'
import Helmet from 'react-helmet'
import { Container, Row, Col } from 'react-grid-system'
import Img from 'gatsby-image'
import heroStyles from '../components/hero.module.css'
import indexStyles from '../templates/blog-post.module.css'

class WeddingsIndex extends React.Component {
    render() {
  
      const [page] = get(this, 'props.data.allContentfulContentPage.edges')
    
      return (
        <div style={{ background: '#fff' }}>
        <Helmet title="Weddings | Signature Party Styling &amp; Rentals"  />
        <div className={heroStyles.hero}>
          <Img className={heroStyles.heroImage} alt={page.node.title} sizes={page.node.image.sizes} />
        </div>
        <div className={indexStyles.blogPageWrapper}>
          <h1 className="section-headline">{page.node.title}</h1>
          <div className={indexStyles.sectionRTE} style={{marginBottom: '50px'}}
            dangerouslySetInnerHTML={{
              __html: page.node.content.childMarkdownRemark.html,
            }}
          />
        </div>
      </div>
      )
    }
  }
  
  export default WeddingsIndex

  export const pageQuery = graphql`
  query WeddingPageQuery {
    allContentfulContentPage (filter: { id: { eq: "c6ZQmPgKLPA9y43gObYqZcp" } }) {
      edges {
        node {
          title
          content {
            childMarkdownRemark {
              html
            }
          }
          image {
            sizes(
              maxWidth: 1500
              resizingBehavior: FILL
              background: "rgb:000000"
            ) {
              ...GatsbyContentfulSizes_withWebp
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/weddings.js